export default {
  namespaced: true,
  state: {
    loading: false,
  },
  mutations: {
    SET_LOADING(state, val) {
      state.loading = val;
    },
  },
  actions: {
    startLoading({ commit }) {
      commit("SET_LOADING", true);
    },
    stopLoading({ commit }) {
      commit("SET_LOADING", false);
    },
  },
  getters: {
    isLoading: (state) => state.loading,
  },
};
